import { SearchField } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import * as state from '../../_state/purchaseOrderList.state';

export const PurchaseOrderListFilterBar = () => {
  const [searchParam, setSearchParam] = useAtom(state.$searchParam);

  return (
    <div className="@PurchaseOrderListFilterBar flex w-full items-center p-4">
      <SearchField
        autoFocus
        placeholder="Search purchase orders"
        className="h-[34px] w-[250px] [&>div]:h-full"
        value={searchParam}
        onChange={(value) => setSearchParam(value)}
      />
    </div>
  );
};
